import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

/**
 * Translates table column titles and nested children titles
 */
export const translateColumns = <T = any>(
  cols: ColumnsType<T> | any[] | undefined,
  t: TFunction | ((key: string, fallback?: string) => string)
): any => {
  if (!cols) return [];
  return (cols as any[]).map((col: any) => {
    if (!col) return col;
    return {
      ...col,
      title:
        typeof col.title === "string"
          ? t(col.title, col.title)
          : col.title,
      children: col.children ? translateColumns(col.children, t) : undefined,
    };
  });
};
